import { useGreeterVenueApi } from "@greeter/matter";
import { WardrobeOverviewPage } from "./WardrobeOverviewPage";

export function WardrobeOverviewPageApiHandler({
  showBackButton = false,
}: {
  showBackButton?: boolean;
}) {
  const { api } = useGreeterVenueApi();
  return <WardrobeOverviewPage api={api} showBackButton={showBackButton} />;
}
